import styled, { css } from 'styled-components'
import { Root, Trigger as RawTrigger } from '@radix-ui/react-collapsible'
import { breakpoint } from '@sketch/global-styles'
import { Button, ButtonBaseStyle } from '@sketch/components'
import { ReactComponent as DropdownIcon } from '@sketch/icons/chevron-down-17'

export const Container = styled(Root)``

export const CollapsibleContainer = styled.div<{
  $isCollapsed?: boolean
  noPadding?: boolean
  noMarginBottom?: boolean
}>(
  ({ $isCollapsed, noPadding, noMarginBottom }) => css`
    overflow: hidden;
    padding: ${noPadding ? 0 : '0 20px'};
    margin-bottom: ${noMarginBottom && !$isCollapsed ? undefined : '8px'};

    div[label='Color'] {
      max-width: 163px;
    }

    /* overrides the sub header (like text alignment) margin top */
    .header-container {
      margin-top: 4px !important; /* stylelint-disable-line declaration-no-important */
    }
  `
)

export const Title = styled.div(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.D};
    font-weight: ${theme.fontWeights.semibold};
    color: ${theme.colors.foreground.secondary.B};
  `
)

export const TitleAndActionsWrapper = styled.div<{ $isCollapsed?: boolean }>`
  display: flex;
  align-items: center;
  padding-left: 20px;
  padding-top: 4px;
  padding-bottom: ${({ $isCollapsed }) => ($isCollapsed ? '4px' : undefined)};

  ${breakpoint('base', 'xs')`
    flex-direction: column;
  `}
`

const actionStyles = css`
  border: none;
  box-shadow: none;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  background-color: transparent;

  &:hover {
    background-color: ${({ theme }) => theme.colors.state.hover};
    color: ${({ theme }) => theme.colors.foreground.secondary.A};

    & > div > svg {
      color: ${({ theme }) => theme.colors.foreground.secondary.A};
    }
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.border.A};
    color: ${({ theme }) => theme.colors.foreground.secondary.A};

    & > div > svg {
      color: ${({ theme }) => theme.colors.foreground.secondary.A};
    }
  }

  &:focus {
    color: ${({ theme }) => theme.colors.foreground.secondary.A};

    & > div > svg {
      color: ${({ theme }) => theme.colors.foreground.secondary.A};
    }
  }
`

export const ActionButton = styled(Button).attrs({
  size: '32',
})`
  ${actionStyles}
`

export const Trigger = styled(RawTrigger)`
  ${ButtonBaseStyle};
  ${actionStyles};
  height: 32px;
  width: 40px;
`

export const CollapseIcon = styled(DropdownIcon)<{ $isCollapsed: boolean }>(
  ({ theme, $isCollapsed }) => css`
    height: 17px;
    width: 17px;
    color: ${theme.colors.foreground.secondary.D};
    transition: transform ${theme.transitions.duration[2]}
      ${theme.transitions.timing.easeInOut};

    ${$isCollapsed &&
    css`
      transform: rotate(-90deg);
    `}
  `
)

export const WarningsContainer = styled.div`
  width: 32px;
  display: flex;
  justify-content: center;
`

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1 0;
  padding-right: 8px;

  ${breakpoint('base', 'xs')`
    justify-content: flex-start;
  `}
`

export const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0;
`
